/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect ,useContext} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
import { HOST_SERVER,LOGIN_ENVIRONMENT,IDLE_TIMEOUT_HOURS, activityEvents, TIMEOUT_LOGOUT } from '../utils/configs';
import moment from 'moment';
import { getCultureFromLs, storageUtil, logoutTimeOutLabel } from '../utils/commonFunctions';
import { languages } from '../utils/languages';
import { ImKey } from "react-icons/im";
import { APIEndpoint } from '../utils/axios';
import { FiAlertTriangle } from "react-icons/fi";
import closeIcon from '../images/icons/Icon2.png';
import PasswordValidator from '../common/PasswordValidation';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import AlertsDropdown from './AlertsDropdown';
import { themesList, setTheme, DEFAULT_THEME_INDEX } from '../utils/themes';
import UserSession from '../utils/userSessionClass';
import { getCurrentMenuItem } from "./SidebarComponent";
import MenuItems from "../assets/json/menuAkasa.json";
import MenuItemsSec from "../assets/json/menuSandbox.json";
import sun from '../assets/sun.svg';
import moon from '../assets/moon.svg';
import sundim from '../assets/sundim.svg';
import moondim from '../assets/moondim.svg';
import { Authorizer } from 'casbin.js';
import enlang from '../assets/enlang.svg';
import leftpanelclose from '../assets/leftpanel-close.svg';
import leftpanelcloseWhite from '../assets/leftpanel-close-white.svg';
import leftpanelopenWhite from '../assets/leftpanel-open-white.svg';
import seperator from '../assets/seperator.svg';
import leftpanelopen from '../assets/leftpanel-open.svg';
import caretSelect from '../assets/caret-up-down.svg';
import frnlang from '../assets/france.svg';
import spainlang from '../assets/spainlang.svg';
import uaelang from '../assets/uaelang.svg';
import signOutSvg from '../assets/icons/svg/signout-icon.svg';
import {ThemeContext} from "../contexts/themeContext";
import { SlGlobe } from "react-icons/sl";
import PortalLogo from '../components/dashboard/PortalLogo';
import usePermissions from "../utils/userPermissions";
import {usePaymentWarning} from "../contexts/usePaymentWarning";
import {PaymentWarningUI} from "../components/PaymentWarning";


export const TopHeaderComponent = (props) => {

  const { t, ready } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const inactivityTimerRef = useRef(null);
  const inactivityInvokeTime = useRef(0);
  const throttleDelay = 1000;
  const userSession = new UserSession();
  const [showAlerts, setShowAlerts] = useState(false);
  const [logoutWait, setLogoutWait] = useState(TIMEOUT_LOGOUT || 180);
  const sessionVals = userSession.getSessionValues();
  const currentLanguageCode = i18next.language || 'en';
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const [themeClassObj, setThemeClassObj] = useState(themesList[DEFAULT_THEME_INDEX]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [logoutPrompt, setLogoutPrompt] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [loginMessage, setLoginMessage] = useState({ text: "" });
  const [updatePassword, setUpdatePassword] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [validatePasswordUpdate, setValidatePasswordUpdate] = useState(true);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [logoOpen,setLogoOpen] = useState(false);
  const [disabledFields, setDisabledFields] = useState(false);
  const [showPass, setshowPass] = useState({ default: false, currentPassword: false, newPassword: false, confirmPassword: false });
  const clearMsgTimer = useRef(null);
  const hoverTimeRef = useRef(null);
  const dropDownTimerRef = useRef(null);
  // New state for menu dropdowns
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [showSubMenuDropdown, setShowSubMenuDropdown] = useState(false);
  const [showSub2MenuDropdown, setShowSub2MenuDropdown] = useState(false);
  // const [showGroupDropdown, setShowGroupDropdown] = useState(false);
  const [MenuItemsList, setMenuItemsList] = useState([]);
  const [permissionObj, setPermissionObj] = useState({});
  const [authorizer] = useState(new Authorizer('manual'));
  const hostType = localStorage.getItem('sType');
  const userRole = localStorage.getItem('userRole');
  const [userType] = useState( storageUtil.get('userType') || '');
  const permissions = localStorage.getItem("userPermissions");
  const menuDropdownRef = useRef(null);
  const subMenuDropdownRef = useRef(null);
  const sub2MenuDropdownRef = useRef(null);
  // const groupDropdownRef = useRef(null);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const langDropdownRef = useRef(null);
  const {updateTheme} = useContext(ThemeContext);
  const paymentWarning = usePaymentWarning(sessionVals?.user_id);
  const { hasPermission: viewAlertsIcon } = usePermissions('view', "portal.menu.alerts");

  const locationMap = JSON.parse(localStorage.getItem('NGO_CULTURE'))?.timezone?.name ?? "";
  const isDark = themeClassObj.keyname === "themedark";

  let heading = location.state;
  if (!heading) {
    heading = getCurrentMenuItem(location);
  }

  // Get filtered menu items based on permissions
  const convertPath = (originalPath) => {
    if (originalPath) {
      const parts = originalPath.split('.');
      const lastPart = parts[parts.length - 1];
      if (lastPart !== 'alerts') {
        return `/${lastPart}`;
      } else {
        return `/alertsWarnings`;
      }
    }
  }

  useEffect(() => {
    if (hostType && userRole) {
      if (permissions) {
        const permissionsObject = JSON.parse(permissions);
        
        const cleanedUserRole = userRole.replace(/"/g, "");
        const permissionData = permissionsObject[cleanedUserRole];

        authorizer.setPermission(permissionData);
      }
    }
  }, [hostType, userRole, permissions]);

  useEffect(() => {
    if (authorizer && authorizer?.permission) {
      setPermissionObj(authorizer?.permission)
    }
  }, [hostType]);

  useEffect(() => {
    if (permissionObj) {
      const { actObjData } = permissionObj;
      let ngoMenu = HOST_SERVER === process.env?.REACT_APP_API_SERVER ? MenuItems : MenuItemsSec;
      
      if (ngoMenu) {
        setMenuItemsList(
          ngoMenu.map(ml => {
            if (!ml) return null;

            if (ml?.type && ml.type === "menuHeader") {
              // Menu Header
              return ml;
            }
            else {
              // Regular Menu Item
            }

            if (actObjData && actObjData.has('view')) {
              const urls = actObjData.get('view');
              if (Array.isArray(urls)) {
                if (urls.some(p => p === ml.pathPermission)) {
                  const filteredSubItems = ml.subItems
                        ? ml.subItems
                            .map(sI => sI.type === "menuHeader"
                              ? { ...sI, subItems2: (sI.subItems2 || []).filter(child => urls.some(s => s === child.pathPermission)) }
                              : sI)
                            .filter(sI => sI.type === "menuHeader"
                              ? sI.subItems2.length > 0
                              : urls.some(s => s === sI.pathPermission))
                        : [];

                  if (filteredSubItems.length === 0 && (ml.key === 'reports' || ml.key === 'dashboard' || ml.key === 'loyalty' || ml.key === 'alertsWarnings')) {
                    return {
                      ...ml,
                      path: convertPath(ml.path),
                      subItems: []
                    };
                  }

                  return {
                    ...ml,
                    subItems: filteredSubItems
                  };
                }
                else if (urls.some(p => p === ml.path)) {
                  const filteredSubItems = ml.subItems
                        ? ml.subItems
                            .map(sI => sI.type === "menuHeader"
                              ? { ...sI, subItems2: (sI.subItems2 || []).filter(child => urls.some(s => s === child.pathPermission)) }
                              : sI)
                            .filter(sI => sI.type === "menuHeader"
                              ? sI.subItems2.length > 0
                              : urls.some(s => s === sI.pathPermission))
                        : [];

                  if (filteredSubItems.length === 0 && (ml.key === 'reports' || ml.key === 'dashboard' || ml.key === 'loyalty' || ml.key === 'alertsWarnings' || ml.key === 'logs')) {
                    return {
                      ...ml,
                      path: convertPath(ml.path),
                      subItems: []
                    };
                  }

                  return {
                    ...ml,
                    subItems: filteredSubItems
                  };
                }
              }
            }


            return null;
          }).filter(item => item !== null)

        );
      }
    }
  }, [permissionObj, hostType]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target)) {
        setShowMenuDropdown(false);
      }
      if (subMenuDropdownRef.current && !subMenuDropdownRef.current.contains(event.target)) {
        setShowSubMenuDropdown(false);
      }
      if (sub2MenuDropdownRef.current && !sub2MenuDropdownRef.current.contains(event.target)) {
        setShowSub2MenuDropdown(false);
      }
      if (langDropdownRef.current && !langDropdownRef.current.contains(event.target)) {
        setShowLangDropdown(false);
      }
    };

    const handleBeforeUnload = () => {
      ///clearing the session on reloading..
      sessionStorage.removeItem('pageFiltersFinalized');
      sessionStorage.removeItem("pageStateSynced");
      sessionStorage.removeItem('sectorsDynm');
      sessionStorage.removeItem('secISoDynamic');
      sessionStorage.removeItem('pageState');

      sessionStorage.removeItem('SectorData');
      sessionStorage.removeItem('orderCreateList');
      sessionStorage.removeItem('opnPnl');
      sessionStorage.removeItem('Sectors');
      sessionStorage.removeItem('sectorsIsl');
      sessionStorage.removeItem('sectIsl');
      sessionStorage.removeItem('SchedDat');
      sessionStorage.removeItem('eventLg');
      sessionStorage.removeItem('SectorEdited');
      sessionStorage.removeItem('storL');
      sessionStorage.removeItem('emple');
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if(hoverTimeRef.current){
        clearTimeout(hoverTimeRef.current)
      }
    };
  }, []);


  const startInactivityTimer = (e) => {
    const currTime = Date.now();
    if (currTime - inactivityInvokeTime.current >= throttleDelay) {
      inactivityInvokeTime.current = currTime;
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      inactivityTimerRef.current = setTimeout(() => {
        setLogoutPrompt(true);
      }, IDLE_TIMEOUT_HOURS)
    }
  };

  useEffect(() => {
    if (logoutPrompt) {
      if (logoutWait === 0) {
        setLogoutPrompt(false);
        logoutTimeCheck();
        return;
      }
      const intervalId = setInterval(() => {
        setLogoutWait((prev) => prev - 1);
      }, throttleDelay);
      return () => clearInterval(intervalId);
    }
  }, [logoutWait, logoutPrompt]);

  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t]);

  const setUserTheme = (theme = themesList[0]) => {
    setThemeClassObj(theme);
    setTheme(theme);
  };

  useEffect(() => {
    let theme = themeClassObj;
    if (storageUtil.get('theme', 'local') && typeof storageUtil.get('theme', 'local') === 'object') {
      theme = storageUtil.get('theme', 'local');
    }

    setUserTheme(theme);
    startInactivityTimer();
    activityEvents.forEach(event =>
      window.addEventListener(event, startInactivityTimer)
    );

    return () => {
      activityEvents.forEach(event =>
        window.removeEventListener(event, startInactivityTimer)
      );
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (heading && heading?.title && ready) {
      document.title = `${t('company.productName')} ` + (typeof heading.title === 'string' ? t(heading.title.split('-')[0]) : t(`pages.${heading.title?.key ?? '--'}`));

      if (heading.subTitle) {
        document.title += ' - ' + t(`pages.${heading.title.key}Sub.${heading.subTitle.key}`);

        if (heading.subMenuItem2) {
          document.title += ' - ' + t(`pages.${heading.title.key}Sub.${heading.subTitle.key}Sub.${heading.subMenuItem2.key}`);
        }
      }
    } else {
      document.title = 'nGO Pro';
    }
  }, [ready, heading]);

  useEffect(() => {

    if (showDropdown) {
      dropDownTimerRef.current = setTimeout(() => {
        setShowDropdown(false);
      }, 10000);
    }
    return ()=>{
      if(dropDownTimerRef.current){
        clearTimeout(dropDownTimerRef.current)
      }
    }
  }, [showDropdown]);

  const getCountryFlags = (country_code) => {
    if (country_code === "en") {
      return <img width="22px" height="22px" alt='English Flag' src={enlang} />
    } else if (country_code === "fr") {
      return <img width="22px" height="22px" alt='French Flag' src={frnlang} />
    } else if (country_code === "sp") {
      return <img width="22px" height="22px" alt='Spanish Flag' src={spainlang} />
    } else if (country_code === "ar") {
      return <img width="22px" height="22px" alt='Arabic Flag' src={uaelang} />
    }
  }

  const settingsMenu = () => {
    setShowPasswordChange(true);
    setShowDropdown(false);
  }

   const signOutHandler = () => {
    // Clear session data
    storageUtil.clear('sType','local')
    storageUtil.clear('pageStateSynced','session')
    storageUtil.clear('pageState','session')
    storageUtil.clear('pageFiltersFinalized','session')
    storageUtil.clear('','local');
    userSession.destroySession();
    navigate('/login');
  };

  const logoutTimeCheck = () => {
    signOutHandler();
  }

  const onClose = () => {
    setShowPasswordChange(false);
    setUpdatePassword({ currentPassword: "", newPassword: "", confirmPassword: "" });
    setLoginMessage({ text: "" });
    setPasswordMatch(false);
    setDisabledFields(false);
  }

  const handleBlockEvent = (e) => {
    e.preventDefault();
  }

const onChangePassword=async()=>{
      setDisabledFields(true);
      let body ={
        currentPassword: updatePassword.currentPassword,
        newPassword:  updatePassword.newPassword,
        confirmPassword: updatePassword.confirmPassword,
        isValidPassword: true
    };
    
      try {
        const userResp = await APIEndpoint.post('employee/updateLoginPassword', body);
        if(userResp){
          const msg = userResp?.message ?? "Password updated successfully. Please login with new password.";
          setLoginMessage({text:msg});
          resetMessages(2500);
        }
      } catch (error) {
        console.error('Login error:', error);
        let erMsg = 'Update Password Error!';
        try {
          let parsedError = JSON.parse(error.message);
          erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
        } catch (_) {}
        setLoginMessage({error:erMsg});
        resetMessages(3500);
      } finally {
      
      }
}

 function resetMessages(tOut=3500){
  if(clearMsgTimer.current){
    clearTimeout(clearMsgTimer.current);
  }
  clearMsgTimer.current= setTimeout(()=>{
    setLoginMessage({text:''});
    setDisabledFields(false);
    setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
  },tOut)
  return clearMsgTimer.current;
}

  // Navigate to menu item
  const handleMenuNavigation = (item, subItem = null, sub2Item = null) => {
    let path = '';
    
    if (sub2Item && sub2Item.path) {
      path = sub2Item.path;
    }
    else if (subItem && subItem.subItems2 && subItem.subItems2.length > 0) {
      path = subItem.subItems2[0].path;
    } else if (subItem && subItem.path) {
      path = subItem.path;
    } else if (item.subItems && item.subItems.length > 0) {
      // If menu has subitems, navigate to first subitem
      path = item.subItems[0].path;
    } else {
      path = item.path;
    }

    navigate(path, {
      state: {
        ...location.state,
        title: item,
        subTitle: subItem || (item.subItems && item.subItems.length > 0 ? item.subItems[0] : null),
        sub2Title: sub2Item || (subItem && subItem.subItems2 && subItem.subItems2.length > 0 ? subItem.subItems2[0] : null)
      }
    });
    
    setShowMenuDropdown(false);
    setShowSubMenuDropdown(false);
    setShowSub2MenuDropdown(false);
  }

  // Get current menu item from heading
  const getCurrentMenu = () => {
    if (!heading || !heading.title) return null;
    return MenuItemsList.find(item => item.key === heading.title.key);
  }

  const getCurrentSubMenu = () => {
    const currentMenu = getCurrentMenu();
    if (!currentMenu || !currentMenu.subItems || currentMenu.subItems.length === 0) return null;
    
    if (heading && heading.subTitle) {
      return heading.subTitle;
    }
    
    // Return first submenu as default
    return currentMenu.subItems[0];
  }

  const getCurrentSub2Menu = () => {
    const currentSubMenu = getCurrentSubMenu();
    const sub2MenuOptions = currentSubMenu?.subItems2 || [];
    if (sub2MenuOptions.length === 0) return null;

    const selectedSub2Menu = heading?.sub2Title || heading?.subMenuItem2;
    if (selectedSub2Menu) {
      const matchedSub2Menu = sub2MenuOptions.find((item) =>
        item.key === selectedSub2Menu.key || item.path === selectedSub2Menu.path
      );
      if (matchedSub2Menu) return matchedSub2Menu;
    }

    // Return the first submenu2 as the default when no route selection matches.
    return sub2MenuOptions[0];
  }

  // Breadcrumb rendering with dropdowns
  const renderBreadcrumb = () => {
    
    if (!heading || !heading.title) return null;
    
    const currentMenu = getCurrentMenu();
    const currentSubMenu = getCurrentSubMenu();
    const currentSub2Menu = getCurrentSub2Menu();

    const subMenuOptions = currentMenu?.subItems || [];
    const sub2MenuOptions = currentSubMenu?.subItems2 || [];

    return (
      <div className="breadcrumb-container">
        <div className="breadcrumb-items">
          <div
            className="breadcrumb-item dropdown"
            ref={menuDropdownRef}
          >
            <button 
              className="breadcrumb-button"
              onClick={() => {
                setShowMenuDropdown((prev) => !prev);
                setShowSubMenuDropdown(false);
                setShowSub2MenuDropdown(false);
              }}
              onMouseEnter={() => {
              clearTimeout(hoverTimeRef.current);
              hoverTimeRef.current = setTimeout(()=>{
              setShowMenuDropdown(true);
              setShowSubMenuDropdown(false);
              setShowSub2MenuDropdown(false);
              },150)
              }}
              onMouseLeave={() => {
                clearTimeout(hoverTimeRef.current);
                setShowSubMenuDropdown(false);
                setShowSub2MenuDropdown(false);
              }}
            >
              {currentMenu?.icon &&<>
                <i className={`menu-icon ${currentMenu.icon}`}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </>}
              <span>{t(`pages.${currentMenu?.key || heading.title.key}`)}</span>
                <img src={caretSelect} alt="" className="menu-icon-img" />
            </button>

            {showMenuDropdown && (
              <div className="breadcrumb-dropdown-menu"
              onMouseLeave={() => {
              clearTimeout(hoverTimeRef.current);
              setShowMenuDropdown(false);
              }}>
                {MenuItemsList.map((item, index) => (
                  <button
                    key={index}
                    className={`dropdown-menu-item ${item.key === currentMenu?.key ? 'active' : ''}`}
                    onClick={() => handleMenuNavigation(item)}
                  >
                     <i className={`menu-icon ${item.icon}`}>
                    <span className="path1"></span>
                    <span className="path2"></span>
                    </i>
                    <span>{t(`pages.${item.key}`)}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          {currentMenu && currentMenu.subItems && currentMenu.subItems.length > 0 && (
            <>
              <img src={seperator} alt="" className="menu-icon-img" />
              <div className="breadcrumb-container">
                <div className="breadcrumb-items">
                    <div
                      className="breadcrumb-item dropdown"
                      ref={subMenuDropdownRef}>
                      <button 
                        className={`breadcrumb-button ${currentSubMenu ? 'active' : ''}`}
                        onClick={() => {
                            setShowSubMenuDropdown((prev) => !prev);
                            setShowMenuDropdown(false);
                            setShowSub2MenuDropdown(false);
                          }}
                          onMouseEnter={() => {
                          clearTimeout(hoverTimeRef.current);
                          hoverTimeRef.current = setTimeout(()=>{
                          setShowSubMenuDropdown(true);
                          setShowMenuDropdown(false);
                          setShowSub2MenuDropdown(false);
                          },150)
                        }}
                        onMouseLeave={() => {
                        clearTimeout(hoverTimeRef.current);
                        }}
                      >
                        <div className={`${currentSubMenu ? 'active' : ''} justify-items-between`}>
                          <span>{currentSubMenu ? t(`pages.${currentMenu.key}Sub.${currentSubMenu.key}`) : ''}</span>
                          <span>&nbsp;{subMenuOptions.length > 0 && <img src={caretSelect} alt="" className="menu-icon-img" />}</span>
                        </div>
                        
                      </button>

                      {showSubMenuDropdown && (
                        <div className="breadcrumb-dropdown-menu"
                          onMouseLeave={() => {
                              clearTimeout(hoverTimeRef.current);
                              setShowMenuDropdown(false);
                              setShowSubMenuDropdown(false);
                          }}
                          onMouseEnter={() => {
                            clearTimeout(hoverTimeRef.current);
                            hoverTimeRef.current = setTimeout(()=>{
                              setShowMenuDropdown(false);
                              setShowSubMenuDropdown(true);
                              setShowSub2MenuDropdown(false);
                            },150)
                          }}
                        >
                          {subMenuOptions.map((subItem, index) => (
                            <button
                              key={index}
                              className={`dropdown-menu-item ${subItem.key === currentSubMenu?.key ? 'active' : ''}`}
                              onClick={() => handleMenuNavigation(currentMenu, subItem)}>
                              <span>
                                {currentMenu?.key && subItem?.key &&
                                  <div className="menu-item-container justify-items-between">
                                    <span className="menu-text">{t(`pages.${currentMenu.key}Sub.${subItem.key}`)}</span>

                                    {subItem?.subItems2 && subItem?.subItems2.length > 0 ?
                                      <span className="menu-caret-icon">
                                        &nbsp;&nbsp;<img src={caretSelect} alt="" className="menu-icon-img" />
                                      </span>
                                    : null}
                                  </div>
                                }
                              </span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                </div>
              </div>

                {sub2MenuOptions.length > 0 && (
                  <>
                    <img src={seperator} alt="" className="menu-icon-img" />
                      <div
                        className="breadcrumb-item dropdown"
                        ref={sub2MenuDropdownRef}>
                        <button 
                          className={`breadcrumb-button ${currentSub2Menu ? 'active' : ''}`}
                          onClick={() => {
                            setShowSub2MenuDropdown((prev) => !prev);
                            setShowSubMenuDropdown(false);
                            setShowMenuDropdown(false);
                          }}
                          onMouseEnter={() => {
                          clearTimeout(hoverTimeRef.current);
                          hoverTimeRef.current = setTimeout(()=>{
                          setShowSub2MenuDropdown(true);
                          setShowSubMenuDropdown(false);
                          setShowMenuDropdown(false);
                          },150)
                          }}
                          onMouseLeave={() => {
                          clearTimeout(hoverTimeRef.current);
                          }}
                        >
                          <span>{currentMenu && currentSub2Menu && currentSub2Menu ? t(`pages.${currentMenu.key}Sub.${currentSubMenu.key}Sub2.${currentSub2Menu.key}`) : ''}</span>

                          {sub2MenuOptions.length > 1 && <img src={caretSelect} alt="" className="menu-icon-img" />}
                        </button>

                        {showSub2MenuDropdown && (
                          <div className="breadcrumb-dropdown-menu"
                            onMouseLeave={() => {
                              clearTimeout(hoverTimeRef.current);
                              setShowSub2MenuDropdown(false);
                            }}
                            onMouseEnter={() => {
                              clearTimeout(hoverTimeRef.current);
                              hoverTimeRef.current = setTimeout(()=>{
                                setShowSub2MenuDropdown(true);
                              },150)
                            }}
                          >
                            {sub2MenuOptions.map((sub2Item, index) => (
                              <button
                                key={index}
                                className={`dropdown-menu-item ${sub2Item.key === currentSub2Menu?.key ? 'active' : ''}`}
                                onClick={() => handleMenuNavigation(currentMenu, currentSubMenu, sub2Item)}>
                                <span>{t(`pages.${currentMenu.key}Sub.${currentSubMenu.key}Sub2.${sub2Item.key}`)}</span>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    
                  </>
                )}

            </>
          )}

        </div>
      </div>
    );
  };

  return (
    <>
     <PaymentWarningUI {...paymentWarning} />
      <div className="redesigned-header"
              onMouseLeave={() => {
              clearTimeout(hoverTimeRef.current);
              setShowSubMenuDropdown(false);
              setShowSub2MenuDropdown(false);
              setShowMenuDropdown(false);
              }}
      >
        <div className="header-left">

          <div className="menu-toggle-wrapper">
          <span className="tooltip-action">
          {toggleMenu ? t('pages.loginContent.closeSidebar') : t('pages.loginContent.openSidebar')}
          </span>

          <button
          className="menu-toggle-btn"
          onClick={() => {props.onMenu();setToggleMenu(_ => !_)}}
          >
          <img
          src={
          toggleMenu
          ? (isDark ? leftpanelcloseWhite : leftpanelclose)
          : (isDark ? leftpanelopenWhite : leftpanelopen)
          }
          alt="Menu Toggle"
          className="menu-icon-img"
          />
          </button>
          </div>


          <PortalLogo logoHostPath={ HOST_SERVER } APIEndpoint={ APIEndpoint } userType={ userType } logoOpen={logoOpen} setLogoOpen={setLogoOpen} />

          <img src={seperator} alt="" className="menu-icon-img" />
          {renderBreadcrumb()}
        </div>

        <div className="header-right">
          <span className="login-label-logo justifyContentCenter alignItemsCenter">{LOGIN_ENVIRONMENT}</span> 
          <div className="header-info">
            <div title="Select Language" className="flexRow justifyContentCenter alignItemsCenter date-time language-switcher" ref={langDropdownRef}>
              <button
                type="button"
                className="date-display language-globe-btn"
                onClick={() => {
                  setShowLangDropdown((prev) => !prev);
                  setShowDropdown(false);
                }}
                aria-haspopup="true"
                aria-expanded={showLangDropdown}
              >
                <SlGlobe />
              </button>
              {!showLangDropdown && (
                <span className="tooltip-action">
                  {locationMap} · {moment(new Date()).format("ddd DD MMM")} {getCultureFromLs()?.timezone?.formattedName?.split(" ")[1]}
                </span>
              )}
              {showLangDropdown && (
                <div className="breadcrumb-dropdown-menu language-dropdown-menu">
                  {languages.map(({ code, country_code }) => (
                    <button
                      key={country_code}
                      type="button"
                      className={`dropdown-menu-item ${currentLanguage.country_code === code ? 'active' : ''}`}
                      onClick={() => {
                        i18next.changeLanguage(code);
                        setShowLangDropdown(false);
                      }}
                    >
                      {getCountryFlags(code)}
                      <span>{t(`languageNames.${code}`)}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

        {viewAlertsIcon ? <div className="notification-wrapper">
  <button onClick={() => setShowAlerts(prevShowAlerts => !prevShowAlerts)}>
    <i className="margBottom0 icon-alerts h4 flexRow justifyContentCenter alignItemsCenter" />
  </button>
  <span className="notification-badge">8</span>
</div>:<></>}

          <div
            className="user-profile-container"
          >
            <button
              type="button"
              className="user-profile-btn"
              onClick={() => {
                setShowDropdown((prev) => !prev);
                setShowLangDropdown(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setShowDropdown((prev) => !prev);
                  setShowLangDropdown(false);
                }
              }}
              aria-haspopup="true"
              aria-expanded={showDropdown}
            >
              
              <div className="user-avatar">
               {sessionVals?.employeeName!=="null"?sessionVals?.employeeName?.charAt(0).toUpperCase():sessionVals?.username?.slice(0,2).toUpperCase()}
              </div> 
              <i className="icon-chevron-down" />
            </button>

            {showDropdown && (
              <div className={`user-dropdown-menu${currentLanguage.country_code === 'ar' ? '-arabic' : ''}`}>
    
                  <div className="menu-item" style={{cursor:'default'}}>
                    <button
                    className={`theme-toggle-menu ${themeClassObj?.title === 'Dark' ? 'light' : 'dark'}`}
                    type="button"
                    aria-label={t('pages.loginContent.select-theme')}
                    onClick={() => {
                      const currentIndex = themesList.findIndex(
                        t => t.title === themeClassObj.title
                      );
                      const nextIndex = (currentIndex + 1) % themesList.length;
                      setUserTheme(themesList[nextIndex]);
                      updateTheme();
                    }}
                    >
                    <span title={themeClassObj?.title === 'Dark'  ? `${t(`themeNames.${themeClassObj?.title}`)}  ${t('themeNames.Mode')}`  : ``} className="theme-option sun">
                      <img src={themeClassObj?.title === 'Dark' ? sun : sundim} alt="Light theme" />
                    </span>
                  <span title={themeClassObj?.title === 'Light'  ? `${t(`themeNames.${themeClassObj?.title}`)}  ${t('themeNames.Mode')}`  : ``} className="theme-option moon">
                      <img src={themeClassObj?.title === 'Dark' ? moondim : moon} alt="Dark theme" />
                    </span>
                    </button>
                    </div>
                <div className="menu-item" onClick={(e) => {
                  e.stopPropagation();
                  settingsMenu();
                }}>
                  <span ><ImKey /> &nbsp;{t('topHeader.settings')}</span>
                </div>
                    <div className="menu-item exit" onClick={(e) => {
                      e.stopPropagation();
                      signOutHandler();
                    }}>
                  <span ><img src={signOutSvg} alt="" className='menuitemicon' /> {t('topHeader.signout')}</span>
                </div>
               
                <div className="menu-text">
                  <span>{sessionVals?.login_date ?? ''}<br />
                  {t('topHeader.loginAtText')} {sessionVals.login_time}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    <AlertsDropdown 
      showAlerts={showAlerts} 
      setShowAlerts={setShowAlerts} 
    />
      {/* Logout Prompt Modal*/}
      {logoutPrompt && (
        <div className='overlay-logout' role="dialog">
          <div className="dialog2 sm-scrollbar">
            <div className="dialog__header pt-4">
              <div className='flexRow justifyContentCenter'>
                <FiAlertTriangle color='#D7A31A' size='25' style={{ marginRight: '10px' }} />
                <h2 className="dialog__title subheading-text-medium fontMedium">
                  {"Your session is about to expire"}
                </h2>
              </div>
            </div>

            <div className="dialog__content mt-0">
              <div className="dialog__body_container flexRow justifyContentSpaceBetween flexWrap">
                <div className="flexCol justifyContentSpaceEvenly">
                  <div className="dialog__container_item">
                    <div style={{ color: '#ffffff' }} className="margTop40 subheading-text-semibold">
                      <p>{`You will be logged out in ${logoutTimeOutLabel(logoutWait)}`}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="dialog__footer flexRow justifyContentSpaceEvenly pt-2 mb-4">
              <button type="button" className="cancel-button" onClick={logoutTimeCheck}>
                {'Logout'}
              </button>
              <button type="submit" className="done-button" onClick={() => {
                setLogoutPrompt(false);
                setLogoutWait(TIMEOUT_LOGOUT);
                startInactivityTimer()
              }}>
                {'Continue Session'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password Change Modal  */}
      {showPasswordChange && (
        <div className="overlay_hide sub" role="dialog">
          <div className="dialog dialog--change-password" style={{ margin: '10px 0px' }}>
            <div className="dialog__content margTop24">
              <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={onClose} />
              <h2 className="dialog__title subheading-text-medium fontMedium">Change Password</h2>
              <hr style={{ color: '#fff' }} />
              
              {Object.keys(updatePassword).length > 0 ? (
                <PasswordValidator 
                  passwordMatchError={setPasswordMatch} 
                  showValidation={validatePasswordUpdate} 
                  empPassword={true} 
                  isValidPassword={setValidatePasswordUpdate} 
                  passwordFields={updatePassword}
                />
              ) : null}

              <div className="dialog__body_container flexRow justifyContentCenter alignItemsCenter flexWrap">
                <div className="dialog__container_item input-container">
                  <div style={{ color: '#ffff' }} className="dialog__description margBtm15">
                    <label className='req fontRegular margTop16'>
                      {t('pages.loginContent.currentPassword')}
                    </label>
                    <div className='password-input-container'>
                      <input
                        onChange={e => setUpdatePassword((_) => ({ ..._, currentPassword: e.target.value }))}
                        type={showPass.currentPassword ? "text" : "password"}
                        value={updatePassword.currentPassword}
                        onCopy={handleBlockEvent}
                        onPaste={handleBlockEvent}
                        onCut={handleBlockEvent}
                        disabled={disabledFields}
                        className='edit-input'
                      />
                      <span
                        onClick={() => setshowPass(prev => ({ ...prev, currentPassword: !prev.currentPassword }))}
                        className="eye-toggle"
                      >
                        {!showPass.currentPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="dialog__body_container flexRow justifyContentCenter flexWrap">
                <div className="dialog__container_item input-container">
                  <div style={{ color: '#ffff' }} className="flexCol justifyContentCenter alignItemsCenter dialog__description margBtm15">
                    <div style={{ paddingBottom: '10px' }}>
                      <label className='flexRow textAlignLeft req fontRegular margTop16'>
                        {t('pages.loginContent.newPassword')}
                      </label>
                      <div className='password-input-container'>
                        <input
                          onChange={e => setUpdatePassword((_) => ({ ..._, newPassword: e.target.value }))}
                          type={showPass.newPassword ? "text" : "password"}
                          value={updatePassword.newPassword}
                          disabled={disabledFields}
                          onCopy={handleBlockEvent}
                          onPaste={handleBlockEvent}
                          onCut={handleBlockEvent}
                          className='edit-input'
                        />
                        <span
                          onClick={() => setshowPass(prev => ({ ...prev, newPassword: !prev.newPassword }))}
                          className="eye-toggle"
                        >
                          {!showPass.newPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                    {passwordMatch && (
                      <h6 className="small-body-text-regular-label-upload text-danger">
                        {t('warningTexts.passwordMatchUpdate')}
                      </h6>
                    )}
                  </div>
                </div>
              </div>

              <div className="dialog__body_container flexRow justifyContentCenter alignItemsCenter flexWrap">
                <div className="dialog__container_item input-container">
                  <div style={{ color: '#ffff' }} className="flexCol justifyContentCenter alignItemsCenter dialog__description">
                    <div style={{ paddingBottom: '10px' }}>
                      <label className='flexRow textAlignLeft req fontRegular margTop16'>
                        {t('pages.loginContent.confirmPassword')}
                      </label>
                      <div className='password-input-container'>
                        <input
                          onChange={e => setUpdatePassword((_) => ({ ..._, confirmPassword: e.target.value }))}
                          type={showPass.confirmPassword ? "text" : "password"}
                          value={updatePassword.confirmPassword}
                          disabled={disabledFields}
                          onCopy={handleBlockEvent}
                          onPaste={handleBlockEvent}
                          onCut={handleBlockEvent}
                          className='edit-input'
                        />
                        <span
                          onClick={() => setshowPass(prev => ({ ...prev, confirmPassword: !prev.confirmPassword }))}
                          className="eye-toggle"
                        >
                          {!showPass.confirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                    {passwordMatch && (
                      <h6 className="small-body-text-regular-label-upload text-danger">
                        {t('warningTexts.passwordMatchUpdate')}
                      </h6>
                    )}
                  </div>
                </div>
              </div>

              {(loginMessage.text?.length || loginMessage.error?.length) ? (
                <div style={{ padding: '0.2rem', marginBottom: '8px' }} 
                  className={"dialog__statusBlock " + (loginMessage && loginMessage?.error?.length ? 'alert_error' : 'alert_success')}>
                  <h6 className="subheading-text-medium-title fontLight">
                    {loginMessage.text || loginMessage.error}
                  </h6>
                </div>
              ) : null}

              <div className="dialog__footer flexCol alignItemsCenter">
                <button 
                  disabled={validatePasswordUpdate || disabledFields} 
                  className={"done-button"} 
                  onClick={onChangePassword}
                >
                  {"Update Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {!ready && <div className='overlay_hide sub'></div>}
    </>
  );
}